export const expensesDescriptionData = {
  title: 'Describe the out-of-pocket expenses you are claiming for',
  imgObj: {
    src: 'https://media.product.which.co.uk/prod/images/original/50dda39540d4-toolicondocument.jpg',
    alt: '',
  },
  descriptiveText: [
    "Make sure to say why you think the expenses you're claiming for are reasonable and unavoidable.",
  ],
  placeholderText:
    'Eg. the food provided in the package deal was inedible, so I had to buy food elsewhere.',
}
